import React from "react";
import "./Media.css";
import MediaSliderImg1 from "../../Assets/Webp/Media/MediaSliderImg1.webp";
import MediaSliderImg2 from "../../Assets/Webp/Media/MediaSliderImg2.webp";
import MediaSliderImg3 from "../../Assets/Webp/Media/MediaSliderImg3.webp";
import MediaSliderImg4 from "../../Assets/Webp/Media/MediaSliderImg4.webp";
import MediaSliderImg5 from "../../Assets/Webp/Media/MediaSliderImg5.webp";
import MediaSliderImg6 from "../../Assets/Webp/Media/MediaSliderImg6.webp";
import MediaSliderImg7 from "../../Assets/Webp/Media/MediaSliderImg7.webp";
import MediaSliderImg8 from "../../Assets/Webp/Media/MediaSliderImg8.webp";
import MediaSliderImg9 from "../../Assets/Webp/Media/MediaSliderImg9.webp";
import MediaSliderImg10 from "../../Assets/Webp/Media/MediaSliderImg10.webp";
import MediaSliderImg11 from "../../Assets/Webp/Media/MediaSliderImg11.webp";
import MediaSliderImg12 from "../../Assets/Webp/Media/MediaSliderImg12.webp";
import MediaSliderImg13 from "../../Assets/Webp/Media/MediaSliderImg13.webp";
import MediaSliderImg14 from "../../Assets/Webp/Media/MediaSliderImg14.webp";
import ContactSection from "../../Components/ContactSection/ContactSection";

export default function MediaArContent() {
  return (
    <div className="MediaContainer">
      <MediaS1 />
      <MediaS2 />
      <MediaS3 />
    </div>
  );
}

function MediaS1() {
  return (
    <div className="MediaS1">
      <div className="MediaS1P1 ar">وسائط</div>
      <div className="MediaS1P2">
        <div className="MediaS1P2Video">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/3BmEc9_t4eA"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <div className="MediaS1P3 ar">
        ننتج زيًّا رسميًا فاخرًا باستخدام خامات عالية الجودة. باستخدام تكنولوجيا متقدمة وحرفية عالية، نضمن أن كل قطعة تأتي بتفاصيل دقيقة ورعاية فائقة
      </div>
      <div className="MediaS1P4"></div>
    </div>
  );
}

function MediaS2() {
  const isMobile = window.innerWidth <= 765;

  return (
    <>
      {isMobile ? (
        <div className="MediaS2">
          <div className="MediaS2P1">
            <img src={MediaSliderImg1} alt="" className="MS2SImg1N Def" />
            <img src={MediaSliderImg2} alt="" className="MS2SImg2N Def" />
          </div>
          {/*  */}
          <div className="MediaS2P1">
            <img src={MediaSliderImg3} alt="" className="MS2SImg3N Def" />
            <img src={MediaSliderImg4} alt="" className="MS2SImg4N Def" />
          </div>
          {/*  */}
          <div className="MediaS2P1">
            <img src={MediaSliderImg5} alt="" className="MS2SImg5N Def" />
            <img src={MediaSliderImg6} alt="" className="MS2SImg6N Def" />
          </div>
          {/*  */}
          <div className="MediaS2P1">
            <img src={MediaSliderImg7} alt="" className="MS2SImg7N Def" />
            <img src={MediaSliderImg8} alt="" className="MS2SImg8N Def" />
          </div>
          {/*  */}
          <div className="MediaS2P1">
            <img src={MediaSliderImg9} alt="" className="MS2SImg9N Def" />
            <img src={MediaSliderImg10} alt="" className="MS2SImg10N Def" />
          </div>
          {/*  */}
          <div className="MediaS2P1">
            <img src={MediaSliderImg11} alt="" className="MS2SImg11N Def" />
            <img src={MediaSliderImg12} alt="" className="MS2SImg12N Def" />
          </div>
          {/*  */}

          {/*  */}

          <div className="MediaS2P1">
            <img src={MediaSliderImg13} alt="" className="MS2SImg13N Def" />
            <img src={MediaSliderImg14} alt="" className="MS2SImg14N Def" />
          </div>
        </div>
      ) : (
        <div className="MediaS2">
          <div className="MediaS2P1">
            <img src={MediaSliderImg1} alt="" className="MS2SImg1" />
            <img src={MediaSliderImg2} alt="" className="MS2SImg2" />
            <img src={MediaSliderImg3} alt="" className="MS2SImg1" />
          </div>
          {/*  */}
          <div className="MediaS2P1">
            <img src={MediaSliderImg4} alt="" className="MS2SImg1" />
            <img src={MediaSliderImg5} alt="" className="MS2SImg1" />
            <img src={MediaSliderImg6} alt="" className="MS2SImg1" />
          </div>
          {/*  */}
          <div className="MediaS2P1">
            <img src={MediaSliderImg7} alt="" className="MS2SImg7" />
            <img src={MediaSliderImg8} alt="" className="MS2SImg8" />
            <img src={MediaSliderImg9} alt="" className="MS2SImg9" />
          </div>
          {/*  */}
          <div className="MediaS2P1">
            <img src={MediaSliderImg10} alt="" className="MS2SImg1" />
            <img src={MediaSliderImg11} alt="" className="MS2SImg11" />
            <img src={MediaSliderImg12} alt="" className="MS2SImg1" />
          </div>
          <div className="MediaS2P1">
            <img src={MediaSliderImg13} alt="" className="MS2SImg8" />
            <img src={MediaSliderImg14} alt="" className="MS2SImg14" />
          </div>
        </div>
      )}
    </>
  );
}
function MediaS3() {
  return (
    <>
      <div className="MediaS3">
        <ContactSection />
      </div>
    </>
  );
}
